import { render, staticRenderFns } from "./ImportacaoWebservice.vue?vue&type=template&id=6af09ec1&scoped=true&"
import script from "./ImportacaoWebservice.vue?vue&type=script&lang=js&"
export * from "./ImportacaoWebservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af09ec1",
  null
  
)

export default component.exports